export enum ScreenState {
  Mobile = '(max-width: 499.98px)',
  Tablet = '(min-width: 500px) and (max-width: 999.98px)',
  Desktop = '(min-width: 1000px)'
}